<template>
  <div class="flex items-center justify-center">
    <input :id="id" type="radio" name="radio" class="hidden" @change="$emit('activate-edit', index)"/>
    <label :for="id" class="cursor-pointer">
      <span class="w-5 h-5 inline-block rounded-full border border-gray-500"></span>
    </label>
  </div>
</template>

<script>
export default {
  props: ['id', 'index']
}
</script>

<style>
input[type="radio"] + label span {
    transition: background .3s,
      transform .3s;
}

input[type="radio"] + label span:hover,
input[type="radio"] + label:hover span{
  transform: scale(1.2);
} 

input[type="radio"]:checked + label span {
  @apply bg-teal-500 shadow-md;
}

input[type="radio"]:checked + label{
  @apply text-teal-500;
}
</style>